import { i18n } from '@fs/zion-locale'
import { ThingMapPin, ThingCalendar } from '@fs/zion-icon'

export const EventTypeEnum = Object.freeze({
  BIRTH: 'birth',
  DEATH: 'death',
  MARRIAGE: 'marriage',
  CENSUS: 'census',
  NONE: 'none',
})

export const ValidEventTypes = Object.values(EventTypeEnum)

const EVENT_TRANSLATIONS = {
  place: {
    [EventTypeEnum.BIRTH]: { key: 'event-type.birth-place.label', default: 'Birth Place' },
    [EventTypeEnum.DEATH]: { key: 'event-type.death-place.label', default: 'Death Place' },
    [EventTypeEnum.MARRIAGE]: { key: 'event-type.marriage-place.label', default: 'Marriage Place' },
    [EventTypeEnum.CENSUS]: { key: 'event-type.census-place.label', default: 'Census Place' },
  },
  date: {
    [EventTypeEnum.BIRTH]: { key: 'event-type.birth-date.label', default: 'Birth Date' },
    [EventTypeEnum.DEATH]: { key: 'event-type.death-date.label', default: 'Death Date' },
    [EventTypeEnum.MARRIAGE]: { key: 'event-type.marriage-date.label', default: 'Marriage Date' },
    [EventTypeEnum.CENSUS]: { key: 'event-type.census-date.label', default: 'Census Date' },
  },
}

/**
 * Gets translated label for event type and field type combination
 * @param {string} eventType - The event type (birth, death, etc.)
 * @param {'place' | 'date'} type - The field type
 * @returns {string} Translated label
 */
function getEventTranslation(eventType, type) {
  const config = EVENT_TRANSLATIONS[type]?.[eventType]
  if (!config) {
    const fallbackKey = type === 'place' ? 'place-suggest.place.label' : 'date-suggest.date.label'
    const fallbackDefault = type === 'place' ? 'Place' : 'Date'
    return i18n.t(fallbackKey, fallbackDefault)
  }
  return i18n.t(config.key, config.default)
}

export function getPlaceEventByType(eventType) {
  return {
    Icon: ThingMapPin,
    label: getEventTranslation(eventType, 'place'),
  }
}

export function getDateEventByType(eventType) {
  return {
    Icon: ThingCalendar,
    label: getEventTranslation(eventType, 'date'),
  }
}
